module.exports = __webpack_public_path__ + "static/media/datagas-white.4e0d0fd2.png";